import Vue from 'vue';
import bus from './bus';
import mask from './mask';
import messages from './messages';

const install = Vue => {
    Object.defineProperties(Vue.prototype, {
        $bus:   { get() { return bus } },
        $mask:  { get() { return mask } },
        $messages: { get() { return messages }}
    });
};

Vue.use(install);
